import React from 'react';

import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { formatCurrencyValue } from 'utils/format';

import { PropertyAndLoanTestIds } from '../../../../../PropertyAndLoan.testIds';

import {
  breakdownStyles,
  labelStyles,
  rowStyles,
} from './ProposedPrincipalAndInterestTooltip.styles';

// Rendered as the field's `additionalTitle`, which the FormGenerator field wrapper places inside a
// <Typography> (a <p>). Using an inline <Box component="span"> keeps the markup valid (no <p>-in-<p>);
// the Tooltip's breakdown is portaled out of the paragraph.
const ProposedPrincipalAndInterestTooltip = ({
  label,
  principalAndInterest,
  qualifyingPrincipalAndInterest,
}) => (
  <Box component="span" sx={labelStyles}>
    {label}

    <Tooltip
      placement="bottom"
      title={
        <Box
          data-testid={
            PropertyAndLoanTestIds.PROPERTY_EXPENSES_FORM_QUALIFYING_PRINCIPAL_AND_INTEREST_TABLE
          }
          sx={breakdownStyles}
        >
          <Box sx={rowStyles}>
            <Typography component="span" variant="regular14">
              P&I
            </Typography>
            <Typography component="span" variant="regular14">
              {formatCurrencyValue(principalAndInterest)}
            </Typography>
          </Box>
          <Box sx={rowStyles}>
            <Typography component="span" variant="regular14">
              Qualifying P&I
            </Typography>
            <Typography component="span" variant="regular14">
              {formatCurrencyValue(qualifyingPrincipalAndInterest)}
            </Typography>
          </Box>
        </Box>
      }
    >
      <IconButton
        disableRipple
        aria-label="Principal & Interest breakdown"
        data-testid={
          PropertyAndLoanTestIds.PROPERTY_EXPENSES_FORM_QUALIFYING_PRINCIPAL_AND_INTEREST_INFO_BUTTON
        }
        size="small"
      >
        <InfoIcon size={18} />
      </IconButton>
    </Tooltip>
  </Box>
);

ProposedPrincipalAndInterestTooltip.propTypes = {
  label: PropTypes.string.isRequired,
  principalAndInterest: PropTypes.number,
  qualifyingPrincipalAndInterest: PropTypes.number,
};

export default ProposedPrincipalAndInterestTooltip;
